import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import {getSettings} from '../../../selectors/selectors';
import PhoneIcon from '../../ui/svg/Components/PhoneIcon';
import googleMapUtils from '../../../utils/googleMapUtils';
import useStyles from './CollectionSavedAddressText.styles';

const CollectionSavedAddressText = (props) => {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  if (!props.address) return null;
  return (
    <label
      htmlFor={props.id}
      className={classes.collectionSavedAddressText}
      data-test="CollectionSavedAddress__radio-label"
      data-cs-mask
    >
      <div className={classes.fullName} data-test="CollectionSavedAddressText__name">
        {props.shouldUseNewCollectionOverlay ? props.address.organisationName : props.address.name }
      </div>
      <div className={classes.address} data-test="CollectionSavedAddressText__address">
        {props.shouldUseNewCollectionOverlay
          ? `${googleMapUtils.addressFormatter(props.address)}`
          : `${props.address.organisationName}, ${googleMapUtils.addressFormatter(props.address)}`}
      </div>
      {props.contactNumber && (
        <span className={classes.contactNumber} data-test="CollectionSavedAddressText__contactNumber">
          <PhoneIcon className={classes.phoneIcon} />
          {props.contactNumber}
        </span>
      )}
    </label>
  );
};

CollectionSavedAddressText.propTypes = {
  id: PropTypes.number,
  address: PropTypes.shape({
    name: PropTypes.string,
    organisationName: PropTypes.string,
    buildingNameNumber: PropTypes.string,
    line1: PropTypes.string,
    line2: PropTypes.string,
    line3: PropTypes.string,
    line4: PropTypes.string,
    postcode: PropTypes.string,
    countryCode: PropTypes.string,
    courierId: PropTypes.string,
    locationId: PropTypes.string,
  }),
  contactNumber: PropTypes.string.isRequired,
  paddingLeft: PropTypes.bool.isRequired,
  shouldUseNewCollectionOverlay: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    shouldUseNewCollectionOverlay: !!getSettings(state)?.should_use_new_collection_overlay,
  };
}

export default connect(mapStateToProps)(CollectionSavedAddressText);
